import * as api from '../../../api/stone/stoneApi';
import {
  FETCH_STONES_REQUEST,
  FETCH_STONES_SUCCESS,
  FETCH_STONES_FAILURE,
  CREATE_STONE,
  UPDATE_STONE,
  DELETE_STONE
} from '../../types/stone/stoneTypes';

export const fetchStones = () => async (dispatch) => {
  dispatch({ type: FETCH_STONES_REQUEST });
  try {
    const response = await api.fetchStones();
    dispatch({ type: FETCH_STONES_SUCCESS, payload: response.data });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch stones';
    dispatch({ type: FETCH_STONES_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const createStone = (data) => async (dispatch) => {
  try {
    const response = await api.createStone(data);
    const newStone = { id: response.data.id, ...response.data.data };
    dispatch({ type: CREATE_STONE, payload: newStone });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to create stone';
    throw new Error(errorMessage);
  }
};

export const updateStone = (id, data) => async (dispatch) => {
  try {
    const response = await api.updateStone(id, data);
    dispatch({ type: UPDATE_STONE, payload: { id, data } });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update stone';
    throw new Error(errorMessage);
  }
};

export const deleteStone = (id) => async (dispatch) => {
  try {
    const response = await api.deleteStone(id);
    dispatch({ type: DELETE_STONE, payload: id });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete stone';
    throw new Error(errorMessage);
  }
};
